import { Link } from "react-router-dom";
import '../App.css';

function NavTest() {
  return (
    <div className="App">
      <header className="App-header">
        <nav
          style={{
            borderBottom: "solid 1px",
            paddingBottom: "1rem",
          }}
        >
          <Link to="/test/monkeys">Monkeys</Link> |{" "}
          <Link to="/test/roads">Roads</Link>
        </nav>
      </header>
    </div>
  );
}

export default NavTest;
